module.exports = __webpack_public_path__ + "img/foodCorp.fa19bf8c.png";